import { lazy, Suspense } from "react";
import CircularLoader from "../../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../../components/signUp/createAccountMilitary/main"));


const MilitarySignUp = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default MilitarySignUp;